export const getAllowedOrigins = (): string[] => {
  const allowedOrigins = process.env.BLENDER_PUBLIC_API_ALLOWED_ORIGINS;

  if (!allowedOrigins) {
    throw new Error('BLENDER_PUBLIC_API_ALLOWED_ORIGINS is not defined');
  }

  const origins = allowedOrigins.split(',').map((origin) => origin.trim());

  return origins.filter((origin) => origin !== '');
};
